import { render, staticRenderFns } from "./Metricas.vue?vue&type=template&id=0ce006f9&scoped=true&"
import script from "./Metricas.vue?vue&type=script&lang=js&"
export * from "./Metricas.vue?vue&type=script&lang=js&"
import style0 from "./Metricas.vue?vue&type=style&index=0&id=0ce006f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce006f9",
  null
  
)

export default component.exports